import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomButton, Text } from '../../../../../shared/uiComponents';
import { TEXT } from '../../../../../shared/Helpers/colors';
import { ChevronRight } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { CustomTargetProperties, setTargets } from '../../../../../redux/State/clientSlice/sessionSlice';
import { TargetSessionStatuses } from '../../../../../redux/API/ClientAPIHelpers/sessionsProperties';
import { TargetTypes } from '../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import { getTargetSteps } from '../../../../../redux/State/clientSlice/programTargetSlice';

const Target = ({ target }: { target: CustomTargetProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const targets = useSelector((state) => state.session.targets);

	const addTargetHandler = () => {
		const orderId = targets.filter((x) => x.targetStatus !== TargetSessionStatuses.new).length;

		if (target?.type === TargetTypes.TA) {
			dispatch(getTargetSteps({ id: target.id, programId: target.programId }))
				.then(unwrapResult)
				.then((steps) => {
					const newTargets = targets.map((x) => {
						if (x.id === target.id) {
							return {
								...x,
								targetStatus: TargetSessionStatuses.open,
								orderId,
								steps,
							};
						}

						return x;
					});
					dispatch(setTargets(newTargets));
				});

			return;
		}

		const newTargets = targets.map((x) => {
			if (x.id === target.id) {
				return {
					...x,
					targetStatus: TargetSessionStatuses.open,
					orderId,
					steps: null,
				};
			}

			return x;
		});
		dispatch(setTargets(newTargets));
	};

	return (
		<div className="target">
			<div className="text">
				<Text title={target.name} fontWeight="medium" type="psm" />
				<Text title={target.programName} color={TEXT.TERTIARY} type="pxs" />
				<Text title={TargetTypes[target.type]} color={TEXT.TERTIARY} type="pxs" />
			</div>
			<CustomButton iconOnly={<ChevronRight />} buttonType="quaternary" onClick={addTargetHandler} />
		</div>
	);
};

export default Target;
